import { render, staticRenderFns } from "./StoreSelectBox.vue?vue&type=template&id=32b4b57d&lang=pug&"
import script from "./StoreSelectBox.vue?vue&type=script&lang=js&"
export * from "./StoreSelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports